import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDocsHeading: {
        id: 'custom.views.preferences.Your Policy Documents',
        defaultMessage: 'Your Policy Documents'
    },
    policyDocsHeading2: {
        id: 'custom.views.preferences.policyDocsHeading2',
        defaultMessage: 'You’re in control of how you receive your policies, renewals, changes, and invoices. For each of your policies, you can choose between Paper Delivery – printed documents mailed to you – or Electronic Delivery – going paperless and accessing your documents through our portal.'
    },
    policyDocsHeading3: {
        id: 'custom.views.preferences.policyDocsHeading3',
        defaultMessage: '<span>By choosing Electronic Delivery, you consent to receive email communications from Ayr Farmers Mutual Insurance Company and you accept our <a style="text-decoration:none" href="https://www.ayrmutual.com/site/privacy-policy-and-code" target="_blank">Privacy Policy</a></span>'
    },
    policyDocNote: {
        id: 'custom.views.preferences.NoteMsg',
        defaultMessage: 'Please note: making changes to your Document Delivery Preferences may take up to 72hrs to take effect.'
    },
    policyType: {
        id: 'custom.views.preferences.Policy Type',
        defaultMessage: 'Policy Type'
    },
    policyNumber: {
        id: 'custom.views.preferences.Policy Number',
        defaultMessage: 'Policy Number'
    },
    documentPreference: {
        id: 'custom.views.preferences.Document Preference',
        defaultMessage: 'Document Preference'
    },
    policyDocEmailConsent: {
        id: 'custom.views.preferences.policyDocEmailConsentMsg',
        defaultMessage: 'I agree to receiving emails from Heartland Farm Mutual Insurance and/or Kings Mutual Insurance regarding my policy documents.'
    },
    saveChanges: {
        id: 'custom.views.paperless.Save Changes',
        defaultMessage: 'Save Changes'
    },
    saveDocPreferenceSuccess: {
        id: 'custom.views.preferences.Policy Document preferences are successfully updated.',
        defaultMessage: 'Policy Document preferences are successfully updated.'
    },
    saveDocPreferenceError: {
        id: 'custom.views.preferences.Failed to update Document preferences details.',
        defaultMessage: 'Failed to update Document preferences details.'
    },
    policyConsentSelectWarning: {
        id: 'custom.views.preferences.Consent Select Warning',
        defaultMessage: 'Please select consent checkbox to receive policy documents via emails'
    },
    agree: {
        id: 'custom.views.paperless.Agree',
        defaultMessage: 'I Agree to Electronic Delivery'
    },
    renewalDocPrefrence:{
        id: 'custom.views.paperless.Renewal Document Prefernce',
        defaultMessage: 'Renewal Document Prefernce'
    }
});
